import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import API from "../api";
import { Preferences } from "@capacitor/preferences";
import cryptoService from "../services/cryptoService";

import logo from "../assets/logo.png";
import bgLavande from "../assets/bglavande.jpg";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    document.getElementById("email")?.focus();
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const { data } = await API.post("/users/login", {
        email,
        password,
      });

      localStorage.setItem("token", data.token);
      localStorage.setItem("refreshToken", data.refreshToken);
      localStorage.setItem("user", JSON.stringify(data.user));

      await Preferences.set({
         key: "token",
         value: data.token,
      });

      await Preferences.set({
         key: "refreshToken",
         value: data.refreshToken,
      });

      API.defaults.headers.common["Authorization"] = `Bearer ${data.token}`;

try {
  await cryptoService.init();

  const existingKeys = await cryptoService.getKeys();

  if (!existingKeys?.privateKey || !existingKeys?.publicKey) {
    const newKeys = cryptoService.generateKeyPair();

    const keyRes = await API.post("/users/keys", {
  publicKey: newKeys.publicKey,
});

const keyId = keyRes.data.keyId || keyRes.data.id;

if (!keyId) {
  throw new Error("Aucun keyId retourné par le serveur");
}

await cryptoService.saveKeys(
  keyId,
  newKeys.publicKey,
  newKeys.privateKey
);

  }
} catch (cryptoErr) {
  console.error("Erreur init crypto:", cryptoErr);
}
window.location.href = "/";
    } catch (err) {
      setError(
        err.response?.data?.message ||
        "Email ou mot de passe incorrect"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.overlay} />

      <form onSubmit={handleLogin} style={styles.card}>
        <img src={logo} alt="logo" style={styles.logo} />

        <h2 style={styles.title}>Bienvenue</h2>
        <p style={styles.subtitle}>
  Connecte-toi à ton espace ADAM
</p>

        {error && <div style={styles.error}>{error}</div>}

        <div style={styles.inputWrapper}>
          <span style={styles.icon}>✉️</span>
          <input
            id="email"
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={styles.input}
          />
        </div>

        <div style={styles.inputWrapper}>
          <span style={styles.icon}>🔒</span>
          <input
            type="password"
            placeholder="Mot de passe"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={styles.input}
          />
        </div>

        <div style={styles.options}>
         <span
  style={styles.forgot}
  onClick={async () => {
    try {
      if (!email) {
        setError("Entre ton email avant");
        return;
      }

      setError("");

      const response = await fetch(
        "https://api.joss-serveur.duckdns.org/auth/forgot-password",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email,
          }),
        }
      );

      const data = await response.json();

      setError(
        data.message ||
        "Si un compte existe, un email a été envoyé."
      );

    } catch (err) {
      console.error(err);

      setError(
        err.message || "Erreur serveur"
      );
    }
  }}
>
  Mot de passe oublié ?
</span>
        </div>

        <button
          type="submit"
          disabled={loading}
          style={loading ? styles.buttonDisabled : styles.button}
        >
          {loading ? "Connexion..." : "SE CONNECTER"}
        </button>
      </form>
    </div>
  );
}

export default Login;

// ===============================
// 🎨 STYLES FINAL CLEAN
// ===============================
const styles = {
  container: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: 20,
    position: "relative",
    backgroundImage: `url(${bgLavande})`,

    backgroundSize: "cover",
    backgroundPosition: "center",
  },

  overlay: {
    position: "absolute",
    inset: 0,
    background:
      "linear-gradient(to bottom, rgba(244,240,250,0.15), rgba(230,221,244,0.35))",
    
  },

  card: {
    position: "relative",
    zIndex: 2,
    transform: "translateY(-70px)",

    width: "100%",
    maxWidth: 320,
    padding: 24,
    borderRadius: 20,
    display: "flex",
    flexDirection: "column",
    gap: 14,

    background: "rgba(255,255,255,0.88)",
    border: "1px solid rgba(143,174,93,0.20)",
    backdropFilter: "blur(12px)",

    boxShadow: `
      0 20px 60px rgba(0,0,0,0.9),
      0 0 30px rgba(212,175,55,0.08),
      inset 0 0 10px rgba(212,175,55,0.05)
    `,
  },

  logo: {
    width: 90,
  height: 90,
  borderRadius: "50%",
  },

  title: {
    textAlign: "center",
    color: "#3B3450",
    letterSpacing: 6,
    fontSize: 20,
    fontWeight: "700",
  },

  subtitle: {
    textAlign: "center",
    color: "#7B6F8F",
    fontSize: 13,
  },

  error: {
    background: "#7f1d1d",
    color: "#fecaca",
    padding: 10,
    borderRadius: 8,
    fontSize: 12,
    textAlign: "center",
  },

  inputWrapper: {
  display: "flex",
  alignItems: "center",
  borderRadius: 14,
  paddingLeft: 12,
  background: "rgba(255,255,255,0.9)",
  border: "1px solid rgba(143,174,93,0.20)",
},

  icon: {
  color: "#8FAE5D",
  marginRight: 10,
},

  input: {
  flex: 1,
  padding: 14,
  border: "none",
  outline: "none",
  background: "transparent",
  color: "#3B3450",
},

  options: {
    display: "flex",
    justifyContent: "flex-end",
  },

  forgot: {
  fontSize: 12,
  color: "#8FAE5D",
  cursor: "pointer",
},

  button: {
    marginTop: 10,
    padding: 14,
    borderRadius: 14,
    border: "none",
    background: "linear-gradient(135deg, #8FAE5D, #9AB86A)",
    color: "#ffffff",
    fontWeight: "700",
    letterSpacing: 1,
    boxShadow: "0 8px 20px rgba(143,174,93,0.25)",
  },

  buttonDisabled: {
    marginTop: 10,
    padding: 14,
    borderRadius: 14,
    border: "none",
    background: "#334155",
    color: "#94a3b8",
  },
};